<ngb-carousel>
  <ng-template ngbSlide *ngFor="let exOf of externalOffers">
    <div class="picsum-img-wrapper">
      <ng-container *ngIf="exOf?.image">
        <img class="image"
             [ngSrc]="exOf?.image.src"
             [width]="imageService.width"
             [height]="imageService.height"
             [priority]="true"
             alt="{{exOf.image.altText}}"
             (click)="navigationService.navigateExtern(exOf.externalURL, true)"/>
      </ng-container>
    </div>
    <div *ngIf="showOfferData" class="carousel-caption"
         (click)="navigationService.navigateExtern(exOf?.externalURL, true)">
      <p appSliderTextStyle
          [appTextStyleAlign]="textAlignValue"
          [appTextStyleColor]="textColorValue"
          [appTextStyleSize]="textFontSize"
          [appTextStyleFamily]="textFontFamily"
          [innerHTML]="exOf?.header">
      </p>
      <p appSliderTextStyle
          [appTextStyleAlign]="textAlignValue"
          [appTextStyleColor]="textColorValue"
          [appTextStyleSize]="textFontSize"
          [appTextStyleFamily]="textFontFamily"
          [innerHTML]="exOf?.description">
      </p>
    </div>
  </ng-template>
</ngb-carousel>
